export default __webpack_public_path__ + "static/media/Bryant.a5a71272.png";